import { HttpMethod } from "../../common/constants/http-requests";
import { httpRequest } from "../../common/utils/http-request";
import { HISTORY_API } from "../api";

export const getChangesHistory = ({tableName, tableIdentifierKey}) =>
httpRequest({
  url: `${HISTORY_API}/TableName/${tableName}/TableIdentifierKey/${tableIdentifierKey}`,
  method: HttpMethod.GET,
})